import { getServerSidePropsWithI18n } from "../utils/i18n";

import Main from "./Main";

export const getServerSideProps = getServerSidePropsWithI18n(["main-landing"]);

export default function MainPage() {
  return <Main />;
}
